import { useEffect, useState } from 'react'
import {
  Relationships,
  useGetSfUserRelationshipsQuery,
} from 'store/api-slices/userSlice'

type UseSeparateFriendsAndFamilyResult = {
  friends: Relationships[]
  family: Relationships[]
}

type UseUserRelationshipsResult = {
  friends: Relationships[]
  family: Relationships[]
  isLoading: boolean
  error: any
}
export const useUserRelationships = (): UseUserRelationshipsResult => {
  const { data, error, isLoading } = useGetSfUserRelationshipsQuery()
  const [friends, setFriends] = useState<Relationships[]>([])
  const [family, setFamily] = useState<Relationships[]>([])

  useEffect(() => {
    if (data) {
      const { friends, family } =
        data.reduce<UseSeparateFriendsAndFamilyResult>(
          (acc, relationship) => {
            if (relationship.type === 'Friend') {
              acc.friends.push(relationship)
            } else if (relationship.type === 'Family') {
              acc.family.push(relationship)
            }
            return acc
          },
          { friends: [], family: [] },
        )

      setFriends(friends)
      setFamily(family)
    }
  }, [data])

  return { friends, family, error, isLoading }
}
